import {
  DeliveryStatusItemT,
  DeliveryStatusT,
  EventPayloadT,
} from 'lib-shared-legacy-types';

export const webhooksBasePath = '/settings/integrations/webhooks';
export const helpCenterArticleUrl = 'https://docs.dixa.io/docs/webhooks-guide';

export const readablePaths: Record<string, string> = {
  settings: 'Settings',
  integration: 'Integration',
};

export const parseEventPayload = (payload: string): EventPayloadT | null => {
  try {
    return JSON.parse(payload);
  } catch {
    return null;
  }
};

export const mapDeliveryStatuses = (
  statuses: DeliveryStatusItemT[],
): Record<string, DeliveryStatusT> =>
  statuses.reduce((acc, value) => {
    acc[value.fqn] = value.delivery_status;
    return acc;
  }, {});
